<template>
  <div class="login-state" style="display: none">
    <transition name="van-slide-up">
      <div class="login-menu">
        <img
          v-if="showAdEntra"
          class="img-meet-ad"
          @click="openAd()"
          src="../../assets/images/icon-ad.png"
          alt=""
        />
      </div>
    </transition>

    <transition name="van-slide-up">
      <div
        class="login-menu logged-in button shadow"
        v-show="loginIsShow && userInfo.isLogin"
      >
        <span class="user-name" @click="toUserCenter">{{
          userInfo && userInfo.userName ? userInfo.userName : ""
        }}</span>
        <span class="icontemp logout-a u-logout" @click="logout"></span>
      </div>
    </transition>

    <div v-if="tenantPermInfo && tenantPermInfo.isDisabledVoteQueDown == 2">
      <transition name="van-slide-up">
        <div
          class="wap-share-box"
          v-show="loginIsShow && webinarInfo.posterStatus == '1'"
        >
          <span
            class="icon icontemp shaerd i-shared-wap"
            @click="gotoPoster()"
          ></span>
        </div>
      </transition>
      <transition name="van-slide-up">
        <div
          class="login-menu"
          v-show="loginIsShow"
          v-if="template.meeting.interact_file_icon.display.value"
        >
          <span class="icontemp form i-more" @click="showFile"></span>
        </div>
      </transition>
      <transition name="van-slide-up">
        <div
          class="login-menu"
          v-show="loginIsShow"
          v-if="template.meeting.interact_vote_icon.display.value"
        >
          <span class="icontemp storied i-more" @click="getVote"></span>
        </div>
      </transition>
      <transition name="van-slide-up">
        <div
          class="login-menu"
          v-show="loginIsShow"
          v-if="template.meeting.interact_question_icon.display.value"
        >
          <span class="icontemp volume i-more" @click="questionary"></span>
        </div>
      </transition>
      <transition name="van-slide-up">
        <div
          class="login-menu"
          v-show="loginIsShow"
          v-if="template.meeting.interact_luckdraw_icon.display.value"
        >
          <span
            class="icontemp lottery i-more"
            @click="getLuckyDrawRoster()"
          ></span>
        </div>
      </transition>
    </div>

    <div class="login-menu" v-show="loginMenuIsShow">
      <span class="icontemp more i-more" @click="toggle()"></span>
    </div>
  </div>
</template>
<script>
import { $subscriber, ck, cr } from "fire-wind-water";
import URL from "../../assets/conf/setting.json";
import { mixinsTemplate } from "../../common/mixinsTemplate";
import { logout } from "../../common/joinMeeting";
export default {
  name: "Interaction",
  mixins: [mixinsTemplate],
  data() {
    return {
      loginIsShow: false,
      userInfo: null,
      webinarInfo: {},
      loginMenuIsShow: true,
      isMeetingInfo:
        window.location.href.indexOf("meetingInfo") > -1 ? true : false,
      showAd: false,
      showAdEntra: false
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.isLogin = false;
      this.loginMenuIsShow = true;
      $subscriber.subscribe("webinarInfo", data => {
        this.webinarInfo = data;
      });
      $subscriber.subscribe("setUserName", data => {
        const userInfo = window.$sk.webinar.get().user;
        this.userInfo = userInfo;
      });
      if (this.webinarInfo.posterShareUrl) {
        const userInfo = window.$sk.webinar.get().user;
        this.webinarInfo.posterShareUrl = this.webinarInfo.posterShareUrl.replace(
          "#/",
          "&markCode=" + userInfo.markCode + "#/"
        );
      }
      $subscriber.subscribe("userInfo", data => {
        this.userInfo = data;
        if (
          data.markCode &&
          data.markCode !== "" &&
          this.webinarInfo.posterShareUrl &&
          this.webinarInfo.posterShareUrl.indexOf("markCode") == -1
        ) {
          this.webinarInfo.posterShareUrl = this.webinarInfo.posterShareUrl.replace(
            "#/",
            "&markCode=" + data.markCode + "#/"
          );
        }

        this.showAdEntra = false;
        if (this.webinarInfo.adList) {
          cr.each(this.webinarInfo.adList, item => {
            if (
              item.adDevice == "wap" &&
              this.pctemplate.meeting &&
              ((item.adType == "2" &&
                item.adContent &&
                this.pctemplate.meeting.ad.display.value) ||
                (item.adType == "1" &&
                  this.pctemplate.meeting.adimage.display.value))
            ) {
              this.showAdEntra = true;
            }
          });
        }

        //处理隐藏设置按钮
        //1 总控开 单独控制
        if (
          (this.tenantPermInfo.isDisabledVoteQueDown != 2 ||
            (!this.template.meeting.interact_file_icon.display.value &&
              !this.template.meeting.interact_vote_icon.display.value &&
              !this.template.meeting.interact_question_icon.display.value &&
              !this.template.meeting.interact_luckdraw_icon.display.value)) &&
          !this.userInfo.isLogin
        ) {
          this.loginMenuIsShow = false;
        }
      });

      $subscriber.subscribe("hideWapshowAd", data => {
        this.showAd = false;
        if (!ck.cookie("user_ad_" + data.id)) {
          ck.cookie("user_ad_" + data.id, "1", {
            expires: 1,
            domain: window.$sk.config.domain,
            path: "/"
          });
        }
      });
    },
    toggle() {
      this.loginIsShow = !this.loginIsShow;
    },
    getLuckyDrawRoster() {
      $subscriber.emit("getLuckyDrawRoster");
    },
    showFile() {
      $subscriber.emit("showFile");
    },
    logout() {
      this.isLogin = false;
      return logout(this.webinarInfo);
    },
    //海报
    gotoPoster() {
      const userInfo = window.$sk.webinar.get().user;
      if (userInfo.markCode) {
        this.webinarInfo.posterShareUrl = this.webinarInfo.posterShareUrl.replace(
          "#/",
          "&markCode=" + userInfo.markCode + "#/"
        );
      }
      window.$sk.goto(this.webinarInfo.posterShareUrl, true).subscribe(res => {
        window.open(res);
      });
    },
    getVote() {
      $subscriber.emit("clickOnVote", "shoudong");
    },
    toUserCenter() {
      window.$sk
        .goto(
          URL.template.usercenterUrl +
            "index.html?tenantId=" +
            this.webinarInfo.tenantId +
            "&schemaId=" +
            this.webinarInfo.schemaId +
            "&memberFormId=" +
            this.webinarInfo.registrationFormId,
          true
        )
        .subscribe(res => {
          window.open(res);
        });
    },
    questionary() {
      $subscriber.emit("showQuestion", "shoudong");
    },
    openAd() {
      this.showAd = true;
      $subscriber.emit("showWapshowAd");
    }
  },

  created() {}
};
</script>
